<div class="push-live-confirmation">
  <form (submit)="submit()">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.TITLE' | translate }}
        </mat-card-title>
        <mat-card-subtitle class="subtitles">
          {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.DESCRIPTION' | translate }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content style="margin-top: 24px">
        <section class="sections">
          <mat-card-subtitle class="titles">
            {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.FS_DB.TITLE' | translate }}
          </mat-card-subtitle>
          @for (button of radioButtons; track button) {
            <mat-radio-group
              class="radio-group subtitles"
              [(ngModel)]="options.siteComponents"
              [ngModelOptions]="{ standalone: true }"
              >
              <mat-radio-button class="radio-title-fs-db" [value]="button.value">
                {{ button.title | translate }}
              </mat-radio-button>
              <div class="radio-description-fs-db">
                {{ button.description | translate }}
              </div>
            </mat-radio-group>
          }
        </section>
        <section class="sections">
          <mat-card-subtitle class="titles">
            {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.PRESERVE.TITLE' | translate }}
          </mat-card-subtitle>
          <mat-checkbox [(ngModel)]="options.preserve" [ngModelOptions]="{ standalone: true }" class="subtitles">
            {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.PRESERVE.CHECKBOX' | translate }}
          </mat-checkbox>
        </section>
        <section class="sections">
          <mat-card-subtitle class="titles">
            {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.CONFIRM.TITLE' | translate }}
          </mat-card-subtitle>
          <mat-checkbox [(ngModel)]="confirmChecked" [ngModelOptions]="{ standalone: true }" class="subtitles">
            {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.CONFIRMATION.CONFIRM.CHECKBOX' | translate }}
          </mat-checkbox>
        </section>
        <section class="action-button sections">
          <button type="button" mat-button color="accent" class="cancel-push" (click)="closeDialog()">
            {{ 'BUTTONS.CANCEL' | translate }}
          </button>
          <button type="submit" mat-raised-button color="accent" class="confirm-push" [disabled]="!confirmChecked">
            {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.BUTTONS.MOVE_SITE' | translate }}
          </button>
        </section>
      </mat-card-content>
    </mat-card>
  </form>
</div>
